export const categories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20diverse%20sneaker%20collection%20arranged%20in%20circular%20pattern%20on%20warm%20terracotta%20tile%20floor%2C%20luxury%20streetwear%20footwear%20photography%20with%20rich%20earthy%20tones%20and%20dramatic%20overhead%20lighting&width=600&height=600&seq=cat-001&orientation=squarish",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20knitwear%20and%20hoodie%20stack%20arrangement%20on%20walnut%20wood%20surface%2C%20cozy%20luxury%20apparel%20photography%20with%20warm%20amber%20fireplace%20lighting%20and%20textured%20fabric%20details&width=600&height=600&seq=cat-002&orientation=squarish",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20graphic%20t-shirt%20collection%20hanging%20on%20minimal%20brass%20rod%20against%20sage%20green%20wall%2C%20luxury%20streetwear%20photography%20with%20soft%20natural%20window%20light%20and%20editorial%20composition&width=600&height=600&seq=cat-003&orientation=squarish",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20designer%20jacket%20collection%20on%20industrial%20steel%20clothing%20rack%20against%20exposed%20brick%20wall%2C%20high-end%20outerwear%20fashion%20photography%20with%20moody%20dramatic%20lighting%20and%20urban%20loft%20aesthetic&width=600&height=600&seq=cat-004&orientation=squarish",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20denim%20and%20cargo%20pants%20neatly%20folded%20stack%20on%20natural%20linen%20fabric%20surface%2C%20luxury%20streetwear%20bottoms%20photography%20with%20soft%20morning%20light%20and%20minimalist%20textile%20aesthetic&width=600&height=600&seq=cat-005&orientation=squarish",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20caps%20and%20beanies%20arranged%20in%20gradient%20color%20spectrum%20on%20concrete%20display%20block%2C%20luxury%20streetwear%20accessories%20photography%20with%20bold%20studio%20lighting%20and%20modern%20art%20gallery%20vibe&width=600&height=600&seq=cat-006&orientation=squarish",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20matching%20tracksuit%20set%20flat%20lay%20on%20charcoal%20slate%20surface%20with%20coordinated%20sneakers%20placed%20beside%2C%20luxury%20coordinated%20fashion%20photography%20with%20clean%20geometric%20composition&width=600&height=600&seq=cat-007&orientation=squarish",
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20mens%20underwear%20collection%20neatly%20rolled%20in%20row%20on%20blush%20pink%20marble%20surface%2C%20luxury%20intimate%20apparel%20photography%20with%20soft%20diffused%20lighting%20and%20elegant%20pastel%20aesthetic&width=600&height=600&seq=cat-008&orientation=squarish",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20sports%20jersey%20collection%20on%20hanger%20against%20deep%20navy%20background%20with%20stadium%20lighting%20effect%2C%20luxury%20athletic%20wear%20photography%20with%20dynamic%20shadows%20and%20professional%20sports%20editorial%20style&width=600&height=600&seq=cat-009&orientation=squarish",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20fashion%20accessories%20collection%20arranged%20on%20mirrored%20glass%20surface%20with%20reflections%20including%20sunglasses%20watch%20and%20chain%2C%20luxury%20product%20photography%20with%20glamorous%20studio%20lighting&width=600&height=600&seq=cat-010&orientation=squarish",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20designer%20backpacks%20and%20tote%20bags%20arranged%20in%20pyramid%20formation%20on%20weathered%20oak%20table%2C%20luxury%20accessories%20photography%20with%20warm%20golden%20hour%20lighting%20and%20rustic%20elegant%20composition&width=600&height=600&seq=cat-011&orientation=squarish",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20collection%20coiled%20in%20spiral%20pattern%20on%20antique%20brass%20tray%2C%20luxury%20accessories%20photography%20with%20rich%20cognac%20tones%20and%20vintage%20editorial%20aesthetic&width=600&height=600&seq=cat-012&orientation=squarish",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20perfume%20bottles%20arranged%20on%20crystal%20glass%20shelf%20with%20light%20refracting%20through%20liquid%2C%20luxury%20beauty%20product%20photography%20with%20ethereal%20sparkling%20lighting%20and%20elegant%20composition&width=600&height=600&seq=cat-013&orientation=squarish",
  },
  {
    name: "OtherStuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20miscellaneous%20fashion%20items%20arranged%20in%20treasure%20chest%20style%20wooden%20box%20on%20velvet%20lining%2C%20luxury%20lifestyle%20products%20photography%20with%20warm%20candlelit%20ambiance%20and%20curiosity%20driven%20composition&width=600&height=600&seq=cat-014&orientation=squarish",
  },
];

export const trustBadges = [
  {
    icon: "ri-calendar-check-line",
    title: "Updated Weekly",
    description: "Fresh finds every Monday and Thursday",
  },
  {
    icon: "ri-shield-check-line",
    title: "Verified Sellers",
    description: "Three-step verification process",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "Safe Shopping Tips",
    description: "Protect your every purchase",
  },
  {
    icon: "ri-truck-line",
    title: "Shipping Guides",
    description: "Track from warehouse to door",
  },
  {
    icon: "ri-database-2-line",
    title: "500+ Products",
    description: "Verified across all categories",
  },
];

export const comparisonData = [
  {
    feature: "Weekly Updates",
    kakobuy: "Yes",
    other: "Sometimes",
  },
  {
    feature: "Verified Sellers",
    kakobuy: "Yes",
    other: "No",
  },
  {
    feature: "QC Information",
    kakobuy: "Yes",
    other: "Limited",
  },
  {
    feature: "Buying Guides",
    kakobuy: "Yes",
    other: "No",
  },
  {
    feature: "Shipping Tips",
    kakobuy: "Yes",
    other: "No",
  },
  {
    feature: "Safety Information",
    kakobuy: "Yes",
    other: "No",
  },
];

export const faqs = [
  {
    question: "What is a Kakobuy Spreadsheet?",
    answer: "A Kakobuy Spreadsheet is a curated database of verified fashion products, trusted sellers, and buying guides. It helps shoppers find the best replicas and streetwear items with QC photos, price comparisons, and shipping information all in one organized sheet.",
  },
  {
    question: "Is the kakobuy spreadsheet free to use?",
    answer: "Yes, the core Kakobuy Spreadsheet is completely free to browse and use. Some advanced filtering features and premium seller directories may require a simple registration, but the majority of finds and guides are accessible without any cost.",
  },
  {
    question: "How often is the kakobuy spreadsheet updated?",
    answer: "We publish updates to the Kakobuy Spreadsheet every Monday and Thursday. Our research team continuously monitors seller reviews, new product drops, and price changes to ensure the information stays current and reliable.",
  },
  {
    question: "Can I trust the sellers listed in the spreadsheet?",
    answer: "All sellers in our Kakobuy Spreadsheet pass a strict three-step verification process. We check transaction history, buyer feedback, and QC confirmation before adding any seller. We also mark sellers as 'Verified' or 'Trusted' based on their track record.",
  },
  {
    question: "What is the best category for beginners?",
    answer: "We recommend starting with T-Shirts or Accessories in the Kakobuy Spreadsheet. These categories have lower price points, faster shipping times, and a wide variety of options, making them perfect for first-time buyers.",
  },
  {
    question: "Does the kakobuy spreadsheet include shipping guides?",
    answer: "Yes, every category tab in the Kakobuy Spreadsheet includes shipping estimate columns based on recent user data. We also provide comprehensive shipping guides covering different agents, customs tips, and tracking methods.",
  },
];

export const stats = [
  { number: "10,000+", label: "Monthly Users" },
  { number: "500+", label: "Verified Products" },
  { number: "50+", label: "Buying Guides" },
  { number: "Weekly", label: "Spreadsheet Updates" },
];